module.exports = __webpack_public_path__ + "img/13.dirty_stainless_steel.077ad832.svg";